import { render, staticRenderFns } from "./newCustomeTotalDialog.vue?vue&type=template&id=a23a40c0&scoped=true&"
import script from "./newCustomeTotalDialog.vue?vue&type=script&lang=js&"
export * from "./newCustomeTotalDialog.vue?vue&type=script&lang=js&"
import style0 from "./newCustomeTotalDialog.vue?vue&type=style&index=0&id=a23a40c0&lang=less&scoped=true&"
import style1 from "./newCustomeTotalDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23a40c0",
  null
  
)

export default component.exports